import React, { useEffect } from "react";
import Swal from "sweetalert2";

const CustomAlert = ({
  show,
  title,
  text,
  icon,
  showConfirmButton,
  confirmButtonText,
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    if (show) {
      Swal.fire({
        title: title || "Are you sure?",
        text: text || "This action cannot be undone.",
        icon: icon || "warning",
        showCancelButton: true,
        showConfirmButton: showConfirmButton || false,
        confirmButtonText: confirmButtonText || "დიახ!",
        cancelButtonText: "დახურვა",
      }).then((result) => {
        if (result.isConfirmed && onConfirm) {
          onConfirm(); // Callback for confirm button
        } else if (result.isDismissed && onCancel) {
          onCancel(); // Callback for cancel button
        }
      });
    }
  }, [show, title, text, icon, confirmButtonText, onConfirm, onCancel]);

  return null; // No UI needed; this is programmatically triggered
};

export default CustomAlert;
